import flyByWptImg from "../../../../images/contents/map/fix/Fly-by_WPT.png";
import triangle01Img from "../../../../images/contents/map/fix/triangle_01.png";
import triangle02Img from "../../../../images/contents/map/fix/triangle_02.png";

export const configFixDh = {
  "data": {
    "Type": "GeoJSON",
    "url": "pri/data/AIRAC/%cycle_date%/waypoint/%z%/%y%/%x%.json",
    "cache": true,
    "Grid": {
      "MinZoom": 4,
      "MaxZoom": 6,
      "download_max": 32,
      "BoundingBox": {
        "West": -180.0,
        "South": -90.0,
        "East": 180.0,
        "North": 90.0
      }
    }
  }
};

export const configFixLayer = {
  "Name": "Fix",
  "Renderer": "GeoJSONExt",
  "Attributes": {
    "min_zoom": 6,
    "features": [
      {
        "selector": {
          "type": "key_value",
          "key": "kind",
          "value": "FIX"
        },
        "style": {
          "default": {
            "type": "image",
            "width": 15,
            "height": 15,
            "offset_x": -7,
            "offset_y": -7,
            "url": triangle01Img
          }
        }
      },
      {
        "selector": {
          "type": "key_value",
          "key": "kind",
          "value": "FIXN"
        },
        "style": {
          "default": {
            "type": "image",
            "width": 15,
            "height": 15,
            "offset_x": -7,
            "offset_y": -7,
            "url": triangle02Img
          }
        }
      },
      {
        "selector": {
          "type": "key_value",
          "key": "kind",
          "value": "RNAV"
        },
        "style": {
          "default": {
            "type": "image",
            "width": 15,
            "height": 15,
            "offset_x": -7,
            "offset_y": -7,
            "url": flyByWptImg
          }
        }
      }
    ]
  }
};